import React from 'react';
import { Box, Typography, IconButton } from '@material-ui/core';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import clsx from 'clsx';
import classes from './Header.module.scss';

const Header = ({ title, disabled, hiddenMore, onClickMore, focusing }) => {
  const buttonRef = React.createRef();
  return (
    <Box className={classes.header} display="flex" flexDirection="row">
      <Typography className={classes.title} variant="h1">
        {title}
      </Typography>
      {!hiddenMore && (
        <IconButton
          action={buttonRef}
          disabled={disabled}
          className={clsx(classes.moreBtn, { [classes.focus]: focusing })}
          onClick={onClickMore}
          focusVisibleClassName="focus-visible"
          disableRipple>
          <MoreHorizIcon />
        </IconButton>
      )}
    </Box>
  );
};

export default Header;
